import { config } from '@abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import AUTOCOMPLETE_TELEMETRY from './AutoCompleteTelemetry.graphql';

export const useAutoCompleteTelemetry = (options) =>
  useCustomQuery(AUTOCOMPLETE_TELEMETRY, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'autoCompleteTelemetry',
  });
